import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { tqMutationKeys } from "lib/constants";
import { EvendyApi } from "lib/utils/api-utils";

type DeleteEventPayload = {
  id: number;
};

interface DeleteEventResponse {
  id: number;
  title: string;
  banner: string;
  organizerEmail: string;
  category: string;
  about: string;
  type: string;
  occurrence: string | null;
  timezone: string | null;
  startDate: string | null;
  endDate: string | null;
  status: string;
  location: string;
  publishStatus: string;
  twitter: string | null;
  facebook: string | null;
  linkedin: string | null;
  instagram: string | null;
  deletedAt: string;
  createdAt: string;
  updatedAt: string;
}

type UseDeleteEventResult = UseMutationResult<DeleteEventResponse, Error, DeleteEventPayload>;

export function useDeleteEvent(): UseDeleteEventResult {
  return useMutation({
    mutationFn: async (payload: DeleteEventPayload) => {
      const { id } = payload;
      const res = await EvendyApi.delete<Promise<DeleteEventResponse>>(`event/${id}`);
      return res.data;
    },
    mutationKey: [tqMutationKeys.event.delete],
    onError(deleteError: Error) {
      console.log({ deleteError });
    },
    onSuccess(data) {
      console.log("Event deleted successfully", data);
    },
  });
}
